// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8257":"css/app.6740","8411":"css/admin-app.6740"}[chunkId] + ".css";
};